import apiClient from './client';

export interface ImportRequest {
  entity_type: 'lead' | 'account' | 'contact' | 'activity' | 'task';
  file: globalThis.File;
  mapping?: { [key: string]: string };
  options?: {
    skipDuplicates?: boolean;
    updateExisting?: boolean;
  };
}

export interface ImportError {
  row: number;
  error: string;
  data?: any;
}

export interface ImportResult {
  success: boolean;
  imported: number;
  failed: number;
  errors?: ImportError[];
}

export const importApi = {
  import: async (request: ImportRequest): Promise<ImportResult> => {
    const formData = new FormData();
    formData.append('file', request.file);
    
    // Use the correct endpoint based on entity type
    let endpoint = '/import/leads';
    if (request.entity_type === 'account') {
      endpoint = '/import/accounts';
    } else if (request.entity_type === 'contact') {
      endpoint = '/import/contacts';
    }
    
    const response = await apiClient.post<{ success: boolean; data: ImportResult }>(endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  },
};
